import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { formatAmount } from '../../../../utils/index';

class CashbackByStatusComponent extends React.Component {
    render() {
        const { cssClass, amount, txt } = this.props;

        return (
            <div className={`${cssClass} bloc`}>
                <div className={`${cssClass} header`}>{txt}</div>
                <div className={`${cssClass} footer`}>{formatAmount(amount)}</div>
            </div>
        );
    }
}

CashbackByStatusComponent.propTypes = {
    cssClass: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(CashbackByStatusComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/CashbackByStatusComponent.js